import axios from "axios";
import React, { useEffect } from "react";
import { Container } from "shards-react";
import PageTitle from "../components/common/PageTitle";

export const Analytics = () => {
  const [excelLink, setExcelLink] = React.useState("");

  useEffect(() => {
    fetchDocument();
  }, []);

  const fetchDocument = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        "https://www.googleapis.com/drive/v3/files",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            q: "'1ECR05t4umang5ktMkG8nR404-kREhJkr' in parents and trashed = false",
            fields: "files(id, name, createdTime, modifiedTime, webViewLink)",
            orderBy: "createdTime desc",
          },
        }
      );

      const files = response.data.files;
      setExcelLink(files.at(0)?.webViewLink || "");
    } catch (error) {
      if (error.response?.status === 401) {
        const newToken = await refreshToken();
        if (newToken) {
          localStorage.setItem("token", newToken);
          fetchDocument(); // Simply call again after token refresh
        }
      }
    }
  };

  const refreshToken = async () => {
    try {
      const response = await axios.post("https://oauth2.googleapis.com/token", {
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
        refresh_token: process.env.REACT_APP_OAUTH_REFRESH_TOKEN,
        grant_type: "refresh_token",
      });
      return response.data.access_token;
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  };

  return (
    <Container
      fluid
      className="p-0 pb-4"
      style={{
        height: "90vh",
        overflow: "hidden",
      }}
    >
      <PageTitle title="Análisis" md="12" className="ml-sm-auto mr-sm-auto" />
      <iframe
        id="excelFrame"
        width="100%"
        height="93%"
        allow="autoplay; fullscreen;"
        frameBorder="0"
        src={excelLink}
      ></iframe>
    </Container>
  );
};
